import Module from '../../Module';

class CoverService extends Module {
  /**
   * parse cover
   * @param {Object} cover 
   */
  parseCover(cover) {
    return {
      description: cover.description,
      id: cover.id,
      title: cover.title,
      url: cover.url,
      createdAt: cover.createdAt,
      updatedAt: cover.updatedAt,
      deletedAt: cover.deletedAt,
    }
  }
}

export default new CoverService()
